//logging middleware
import axios from 'axios';
import history from '../helpers/history';

export const logging = store => next => action => {
  if(!action) return;

  switch(action.type) {
    case "CHANGE_LESSON":
      logAction(action, store, "url");
      break;
    case "TOGGLE_PRESSURE_POINT":
      logAction(action, store, "currentPP");
      break;
    case "CORRECT_ANSWER":
      break;
    default:
      logAction(action, store);
      break;
  }

  let result = next(action)
  return result
}

function logAction(action, store, optProp=null){

  const { home, course } = store.getState();

  const user = home.user ?  home.user._id : false;

  if(!user) return;

  if(excludedActions.includes(action.type)) return;

  let opt = null;

  if(optProp){
    opt = {[optProp]: action[optProp]};
  }else if(optActions.includes(action.type)){
    const {type, ...otherProps} = action;
    opt = otherProps;
  }

  const courseUrl = course.url ? course.url : {};

  const log = {
    action: action.type,
    opt: opt,
    course: courseUrl,
    user: user,
    url: history.location.pathname,
  }

  axios.post('/api/logs/', {
    log
  }).then(res => {
    //for debug
    //console.log(res.status);
  }).catch(err => {
    console.log(err);
  });
}


const excludedActions = [
  "FETCH_USER", "RESIZE_WINDOW", "REQUEST_ENTRIES", "REQUEST_COMPLETIONS", "DISABLE_GUIDE", "NEXT_LINE"
];

const optActions = [
  "ADD_MARKED", "REMOVE_MARKED", "COMPLETE_LESSON", "SELECT_LINE"
];


// WEBPACK FOOTER //
// ./src/middleware/logging.js